import { TypedInMemoryProvider } from '@openfeature/web-sdk';

import type { FeatureFlagKey } from '../flags';
import type { FeatureFlagValues } from '../in-memory-config';
import { buildInMemoryFlagConfiguration } from '../in-memory-config';

/**
 * Typed in-memory provider for the web (browser) runtime.
 *
 * Intended for unit/integration tests — flags can be toggled mid-test via
 * {@link setFlag}; the web SDK emits a configuration-changed event so React
 * components re-render with the new value. Also used as the safe fallback
 * when no provider is configured, where it evaluates the registry defaults.
 */
export class WebInMemoryFeatureFlagProvider extends TypedInMemoryProvider {
  private values: FeatureFlagValues;

  constructor(initialValues: FeatureFlagValues = {}) {
    super(buildInMemoryFlagConfiguration(initialValues));
    this.values = { ...initialValues };
  }

  async setFlag(flagKey: FeatureFlagKey, value: boolean): Promise<void> {
    this.values = { ...this.values, [flagKey]: value };
    await this.putConfiguration(buildInMemoryFlagConfiguration(this.values));
  }

  /** Restores every flag to its registry default. */
  async reset(): Promise<void> {
    this.values = {};
    await this.putConfiguration(buildInMemoryFlagConfiguration());
  }
}
